<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Reportes</h4>
            <div class="small text-muted">Administración de todos los reportes</div>
          </b-col>
          <b-col>            
            <b-icon icon="question-circle-fill" class="h3 pull-right mt-2 module-help-information" v-b-popover.hover="help"></b-icon>            
          </b-col>           
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col lg="4">
              <Widget :configWidget="configWidget" reference="indicator_total_reports" :hasAccess="configWidget.elements.indicatorTotalReports" />                            
            </b-col>
            <b-col lg="4"> 
              <Widget :configWidget="configWidget" reference="list_unconfigured_reports" :hasAccess="configWidget.elements.listUnconfiguredReports" />
            </b-col>
          </b-row>
        </b-col>  
        <b-col lg="3">

          <b-list-group class="mb-1" v-if="configSubView.elements.reports">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReport()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Diseño</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Diseño de personalizado de reportes
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.log">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReportLog()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Log</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Muestra un historial de cada reporte generado.
              </p>
            </b-list-group-item>
          </b-list-group>

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.REPORTES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.REPORTES,
          profile_id: Profiles.PERSONAL,
          elements: {             
            indicatorTotalReports: true,        
            listUnconfiguredReports: true,     
          }
        },
        configSubView: {
          module_id: Modules.REPORTES,
          profile_id: Profiles.PERSONAL,
          elements: {
            reports: true,
            log: true,            
            php_custom: true,
          }
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        },        
        help: { 
          title:'¿Cómo funciona este módulo?',
          content: () => { 
            return `Desde este módulo se podrá configurar cada reporte que el sistema necesite para cada módulo.`
          },            
          html: true  
        }      
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.indicatorTotalReports = Helper.hasAccessWidget(this.configWidget, 'indicator_total_reports')
      this.configWidget.elements.listUnconfiguredReports = Helper.hasAccessWidget(this.configWidget, 'list_unconfigured_reports')
      /* Fin configuracion */


      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.reports = Helper.showAccessView(this.configSubView, 'design')            
      this.configSubView.elements.log = Helper.showAccessView(this.configSubView, 'log')                              
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */      
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    computed: {
        
    },       
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openReport() {
        this.$router.push({ name: 'ReportsStaffDesign' })
      },

      openReportLog() {
        this.$router.push({ name: 'ReportsStaffReportLog' })
      },    

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.REPORTES)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }        
    }    
   
  }
</script>